import api from '@/common/api';
import { makeResponse } from '@/common/api/utils';


export const fetchCoinStatistics = async () => (
  makeResponse(
    await api.get(
      'admin/coins/statistics/',
    ),
  )
);

export const fetchAggregationsPerDay = async () => (
  makeResponse(
    await api.get(
      'admin/aggregations/per-day/',
    ),
  )
);

export const fetchAggregations = async () => (
  makeResponse(
    await api.get(
      'admin/aggregations/total/',
    ),
  )
);

export const fetchOrganisations = async () => (
  makeResponse(
    await api.get(
      'admin/organisations/',
    ),
  )
);

export const mergeItems = async (itemFromId, itemToId) => (
  makeResponse(
    await api.post(
      'admin/items/merge/',
      { item_from_id: itemFromId, item_to_id: itemToId },
    ),
  )
);

export const fetchItem = async (itemId) => (
  makeResponse(
    await api.get(
      `admin/items/${itemId}/`,
    ),
  )
);

export const sendMail = async (data, userFilter) => (
  makeResponse(
    await api.post(
      'admin/users/send-mail/',
      data,
      userFilter,
    ),
  )
);

export const createOrganisationMembership = async (organisationSlug) => (
  makeResponse(
    await api.post(
      'admin/organisation-members/',
      { organisation_slug: organisationSlug },
    ),
  )
);

export const updateExternalPartySession = async (externalPartySessionId, isActive) => (
  makeResponse(
    await api.patch(
      `admin/external-party-sessions/${externalPartySessionId}/`,
      { is_active: isActive },
    ),
  )
);

export const fetchUpcomingResearches = async () => (
  makeResponse(await api.get(
    'admin/researches/upcoming/',
  ))
);

export const fetchResearch = async (researchUUID) => (
  makeResponse(await api.get(
    `admin/researches/${researchUUID}/`,
  ))
);

export const copyResearch = async (researchUUID, data) => (
  makeResponse(await api.post(
    `admin/researches/${researchUUID}/copy/`,
    data,
  ))
);

export const unlockResearch = async (researchUUID) => (
  makeResponse(await api.patch(
    `admin/researches/${researchUUID}/unlock/`,
  ))
);

export const fetchLogs = async (page, search) => {
  let url = `admin/logs/?page=${page || 1}`;
  if (search) {
    url += `&search=${search}`;
  }
  return makeResponse(await api.get(
    url,
  ));
};
